'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Anchor = require('./Anchor');

var _Anchor2 = _interopRequireDefault(_Anchor);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _colors = require('./styles/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = function (_ref) {
    var type = _ref.type,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style,
        hoverStyle = _ref.hoverStyle,
        _ref$onClick = _ref.onClick,
        onClick = _ref$onClick === undefined ? function () {
        return null;
    } : _ref$onClick;

    var icon = style.icon,
        anchor = _objectWithoutProperties(style, ['icon']);

    anchor = _extends({
        alignItems: 'center',
        borderRadius: 12,
        display: 'flex',
        height: 24,
        justifyContent: 'center',
        width: 24
    }, anchor);

    hoverStyle = _extends({
        background: _colors.cloud
    }, hoverStyle);

    return _react2.default.createElement(
        _Anchor2.default,
        { style: anchor, hoverStyle: hoverStyle, onClick: onClick },
        _react2.default.createElement(_Icon2.default, { type: type, style: icon })
    );
};
//# sourceMappingURL=IconButton.js.map